/* eslint-disable import/extensions */
/* eslint-disable react/forbid-prop-types */

import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

import { Input } from 'components/Input';
import { Button } from 'components/Button';
import { Title, Text } from 'components/Text';

import { StyledDialog, Content } from './styles';

// Modal de Login por link de email
const EmailModal = ({
  email,
  complete,
  handleChange,
  handleSubmit,
  open, onClose,
}) => {
  const [retry, setRetry] = useState(false);
  const [isComplete, setIsComplete] = useState(false);

  useEffect(() => {
    setIsComplete(complete);
  }, [complete]);

  // Reenvio de link por e-mail
  const resendEmail = (e) => {
    handleSubmit(e);
    setRetry(false);
    setIsComplete(true);
  };

  const handleClose = () => {
    setRetry(false);
    setIsComplete(true);
    onClose();
  };

  // View de reenvio de link
  if (retry) {
    return (
      <StyledDialog
        open={open}
        onClose={handleClose}
      >
        <Content>
          <IconButton
            color="secondary"
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
          <Title>Não recebeu o link?</Title>
          <Text>
            Confira na sua caixa de Spam e na sua Caixa de Entrada. Verifique também se digitou o e-mail corretamente:
          </Text>
          <Text style={{ margin: '15px 0', textAlign: 'center', fontWeight: 500 }}>
            {email}
          </Text>
          <Button onClick={resendEmail}>
            Reenviar link
          </Button>
          <Button
            onClick={() => {
              setRetry(false);
              setIsComplete(false);
            }}
            variant="outlined"
            style={{ border: 0 }}
          >
            Alterar e-mail
          </Button>
        </Content>
      </StyledDialog>
    );
  }

  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
    >
      <Content>
        <IconButton
          color="secondary"
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        {
          isComplete ? (
            // View de confirmação de envio do email
            <>
              <Title>Link de verificação</Title>
              <Text>
                Para logar, clique no link de verificação que enviamos para o email:
              </Text>
              <Text style={{ margin: '15px 0', textAlign: 'center', fontWeight: 500 }}>
                {email}
              </Text>
              <Button
                variant="outlined"
                onClick={() => setRetry(true)}
              >
                Não recebi o link
              </Button>
              {/* <Button
                variant="outlined"
                onClick={() => {
                  setSignMethod('phone');
                  handleClose();
                }}
                style={{ border: 0, fontSize: 14 }}
              >
                Logar com número de celular?
              </Button> */}
            </>
          ) : (
            // View inicial (form de email)
            <>
              <Title>Enviar link de verificação</Title>
              <Text>
                Digite o seu e-mail no campo abaixo para enviarmos um link de verificação
              </Text>
              <form onSubmit={handleSubmit}>
                <Input
                  icon
                  required
                  autoFocus
                  name="email"
                  type="email"
                  value={email}
                  onChange={handleChange}
                  placeholder="E-mail"
                  title="Insira o seu E-mail"
                />
                <Button type="submit">
                  Enviar link por e-mail
                </Button>
              </form>
            </>
          )
        }
      </Content>
    </StyledDialog>
  );
};

EmailModal.propTypes = {
  email: PropTypes.string.isRequired,
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  complete: PropTypes.bool.isRequired,
};

export default EmailModal;
